import { create } from 'zustand';

export const useConnectionStore = create((set) => ({
  isOnline: typeof navigator !== 'undefined' ? navigator.onLine : true,
  wsStatus: 'disconnected',
  setOnline: (isOnline) => set({ isOnline }),
  setWsStatus: (wsStatus) => set({ wsStatus }),
}));

export const connectionStoreInitialState = {
  isOnline: true,
  wsStatus: 'disconnected',
};
